import { CSSProperties, FC } from "react";
import { ReactComponent as GroupGradient } from "../../../../../assets/icons/svg/group-gradient.svg";
import { formatNumberWithSuffix, roundToTwoDecimals } from "../../../../../common/Number";
import { getScoreGrade } from "../../../../../common/Grade";
import { NegotiationIntelligence } from "../../../../../types/DashboardTypes";
import classes from "./Banner.module.less";

interface BannerProps {
    name?: string;
    savings?: number;
    contracts?: number;
    year?: number | null;
    intelligence?: NegotiationIntelligence;
    style?: CSSProperties;
}

export const Banner: FC<BannerProps> = ({
    name = "",
    savings = 0,
    contracts = 0,
    year,
    intelligence,
    style,
}) => {
    const avgScoreGrade = intelligence ? getScoreGrade(intelligence.avgOrderScore) : null;
    const avgOptimizedGrade = intelligence ? getScoreGrade(intelligence.avgOptimizedScore) : null;
    const scoreDiff = intelligence
        ? roundToTwoDecimals(intelligence.avgOrderScore - intelligence.totalAvgScore)
        : 0;
    const diffPrefix = scoreDiff > 0 ? "above" : "below";

    return (
        <div className={classes.container} style={style}>
            <div className={classes.top}>
                <GroupGradient />
                <span>
                    <span className={classes.name}>Hi {name}</span>, you could be saving{" "}
                    <span className={classes.money}>${formatNumberWithSuffix(savings)}</span> across{" "}
                    {contracts} {contracts === 1 ? "analyzed deal" : "analyzed deals"}
                    {year ? ` renewing in ${year}` : ""}.
                </span>
            </div>
            {intelligence && (
                <div className={classes.metrics}>
                    <div className={classes.metricBox}>
                        <div className={classes.metricLabel}>Avg contract score</div>
                        <div
                            className={classes.metricValue}
                            style={{ color: avgScoreGrade?.color }}
                        >
                            {roundToTwoDecimals(intelligence.avgOrderScore)}% (
                            {avgScoreGrade?.grade})
                        </div>
                        <div className={classes.metricDerived}>
                            {Math.abs(scoreDiff)}% {diffPrefix} average
                        </div>
                    </div>
                    <div className={classes.metricBox}>
                        <div className={classes.metricLabel}>Avg optimized contract score</div>
                        <div
                            className={classes.metricValue}
                            style={{ color: avgOptimizedGrade?.color }}
                        >
                            {roundToTwoDecimals(intelligence.avgOptimizedScore)}% (
                            {avgOptimizedGrade?.grade})
                        </div>
                    </div>
                    <div className={classes.metricBox}>
                        <div className={classes.metricLabel}>Total spend</div>
                        <div className={classes.metricValue}>
                            ${formatNumberWithSuffix(intelligence.totalSpend)}
                        </div>
                    </div>
                    <div className={classes.metricBox}>
                        <div className={classes.metricLabel}>Number of deals</div>
                        <div className={classes.metricValue}>{intelligence.orderCount + intelligence.rfxCount}</div>
                    </div>
                </div>
            )}
        </div>
    );
};
